import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';
import timeGridPlugin from '@fullcalendar/timegrid';
import { CalendarOptions } from '@fullcalendar/core';


@Component({
  selector: 'app-matricula',
  templateUrl: './matricula.component.html',
  styleUrls: ['./matricula.component.scss'],
  providers: [DatePipe]
})
export class MatriculaComponent implements OnInit {

  strActualizarDatosPersonales = "api/servicios/ActualizarDatosPersonales";
  strSedes = "api/servicios_profesor/BuscarSedes";
  strPeriodosMatricula = "api/matricula/BuscarPeriodosMatricula";
  strCarreras = "api/matricula/BuscarCarrerasEstudiante";
  strMateriasDisponibles = "api/matricula/BuscarMateriasEstudiante";
  strGruposDisponibles = "api/matricula/ObtenerGruposDisponibles";
  strPrematricular = "api/matricula/Prematricular";
  strEliminarPrematricula = "api/matricula/EliminarPrematricula";
  strConfirmarPrematricula = "api/matricula/ConfirmarPrematricula";
  strFinanciamientos = "api/matricula/BuscarFinanciamientoEstudiante";
  strAutenticar = "api/matricula/ValidarContrasena";
  strGenerarBoleta = "api/matricula/GenerarBoleta";
  strLobbyMatricula = "api/matricula/LobbyMatricula";
  strBuscarPeriodosMatricula = "api/matricula/BuscarPeriodosMatricula";
  strBuscarCarrerasEstudiante = "api/matricula/BuscarCarrerasEstudiante";
  strImg = "";
  strIconoWarning = "assets/images/Icon_Alerta-InformacionAvatar-SyS.png";
  strIconoError = "assets/images/Icon_Alerta-Error_Avatar-SyS.png";
  strIconoSuccess = "assets/images/Icon_Alerta-Aprobado_Avatar-SyS.png";

  contenedor: HTMLElement = document.getElementById("contenedor-estudiante");

  materiaSeleccionada = null;
  grupoSeleccionado = null;
  periodoSeleccionado = null;
  M04IUP = null;
  password = "";
  F08COD = "CNT";
  token = "";

  fechaCalendario: Date;
  activeTab = 1;
  mostrarNoti = true;

  calendarOptions: CalendarOptions = {};

  @Output() cerrarBarra = new EventEmitter<boolean>();

  @Input() ahora: Date = null;
  @Input() sedes = [];
  @Input() sedeSeleccionada = null;
  @Input() datosPersonales = { M12NOM: "", M12AP1: "", M12AP2: "", M12DIR: "", M12TEL: "", M12CEL: "", M12CAR: "", M12EMA: "" };
  @Input() cintillo = "";

  materias = [];
  grupos = [];
  financiamientos = [];
  prematriculadas = [];
  eventos = [];
  periodos = [];
  carreras = [];
  panelesActivos = ["panel-2", "panel-3"];

  confirmacion = { DETALLE: [], MENSAJE: "", ENCABEZADO: { MATRICULA: 0.0, COLEGIATURA: 0.0, OTROS: 0.0, BECAS: 0.0, DESCUENTOS: 0.0, IMPUESTOS: 0.0, SUBTOTAL: 0.0, TOTAL: 0.0 } };
  evento = { title: null, daysOfWeek: [], startRecur: null, startTime: null, endTime: null };
  lobby = {
    TIENE_DEUDAS: "", CITA_MATRICULA: "", TIENE_REQUISITOS_PENDIENTES: "", TERMINOS_AUTORIZADOS: "", BECA: "", TIENE_FINANCIAMIENTO: "NO", DEUDAS: [], REQUISITOS_PENDIENTES: [],
    FECHA_LIMITE: "", FINANCIAMIENTO: ""
  };
  resetLobby = {
    TIENE_DEUDAS: "", CITA_MATRICULA: "", TIENE_REQUISITOS_PENDIENTES: "", TERMINOS_AUTORIZADOS: "", BECA: "", TIENE_FINANCIAMIENTO: "NO", DEUDAS: [], REQUISITOS_PENDIENTES: [],
    FECHA_LIMITE: "", FINANCIAMIENTO: ""
  };
  alertaHtml = { icono: "", mensaje: "" };

  @ViewChild('modalFormalizar') contenido: TemplateRef<any>;

  constructor(private datePipe: DatePipe, private modalService: NgbModal,
    private dataService: SharedService) { }

  ngOnInit(): void {
    if (this.ahora != null) {
      this.fechaCalendario = new Date(this.ahora.getTime());
    } else {
      this.fechaCalendario = new Date();
    }
    this.fechaCalendario.setDate(this.fechaCalendario.getDate() - 7);
    this.evento.startRecur = this.datePipe.transform(this.fechaCalendario, "yyyy-MM-dd");
    this.resetLobby = JSON.parse(JSON.stringify(this.lobby));
  }

  actualizarTablas() {
    this.eventos = [];
    let parametros = { M04IUP: this.M04IUP, M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD, M19COD: this.periodoSeleccionado.M19COD };
    this.dataService.ConsultarWS(this.strMateriasDisponibles, JSON.stringify(parametros)).subscribe((datos: any) => {
      this.materias = datos.DATA;
      this.grupos = [];
      this.prematriculadas = [];


      for (const i in this.materias) {
        if (this.materias[i].PREMATRICULADA == "S") {
          let parametros = { M11COD: this.materias[i].M11COD, M04IUP: this.M04IUP, M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD, M19COD: this.periodoSeleccionado.M19COD };
          this.dataService.ConsultarWS(this.strGruposDisponibles, JSON.stringify(parametros)).subscribe((datos: any) => {
            let gruposMateria = datos.DATA;

            let prematricular;
            for (const j in gruposMateria) {
              if (gruposMateria[j].M23GRU == this.materias[i].M23GRU) {
                prematricular = { materia: null, grupo: null };
                prematricular.materia = this.materias[i];
                prematricular.grupo = gruposMateria[j];
                this.prematriculadas.push(prematricular)
                break;
              }
            }

            let filas = this.formatoHorario(prematricular.grupo.HORARIO, "array");
            for (let l = 0; l < filas.length; l++) {
              let filaEvento = JSON.parse(JSON.stringify(this.evento));
              filaEvento.daysOfWeek = [this.obtenerNumeroSemana(filas[l].substring(0, 1))];
              filaEvento.title = prematricular.materia.M11DES;
              filaEvento.startTime = filas[l].substring(2, 4) + ":" + filas[l].substring(4, 6) + ":00";
              filaEvento.endTime = filas[l].substring(7, 9) + ":" + filas[l].substring(9, 11) + ":00";
              this.eventos.push(filaEvento);
              this.renderCalendario();
            }
          });
        } else {
          this.renderCalendario();
        }
      }
    });
  }

  seleccionMateria(materia) {
    this.materiaSeleccionada = materia;
    let parametros = { M11COD: materia.M11COD, M04IUP: this.M04IUP, M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD, M19COD: this.periodoSeleccionado.M19COD };
    this.dataService.ConsultarWS(this.strGruposDisponibles, JSON.stringify(parametros)).subscribe((datos: any) => {
      this.grupos = datos.DATA;
    }, (err: any) => {
      this.alertaSwal(this.strIconoError, "Error", err);
    });
  }

  prematricularMateria(grupo) {
    let parametros = {
      M04IUP: this.M04IUP, M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD,
      M19COD: this.periodoSeleccionado.M19COD, M11COD: this.materiaSeleccionada.M11COD, M23GRU: grupo.M23GRU
    };
    this.dataService.ConsultarWS(this.strPrematricular, JSON.stringify(parametros)).subscribe((datos: any) => {
      this.actualizarTablas();
    }, (err: any) => {
      this.alertaSwal(this.strIconoError, "Error", err);
    });
  }

  eliminarPrematricula(materia: string, grupo: string) {
    let parametros = {
      M04IUP: this.M04IUP, M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD,
      M19COD: this.periodoSeleccionado.M19COD, M11COD: materia, M23GRU: grupo
    };
    this.dataService.ConsultarWS(this.strEliminarPrematricula, JSON.stringify(parametros)).subscribe((datos: any) => {
      if (this.activeTab == 4) {
        if (this.prematriculadas.length - 1 > 0) {
          this.confirmarPrematricula();
        } else {
          this.confirmacion.DETALLE = [];
          this.activeTab--;
        }
      }
      this.actualizarTablas();
    }, (err: any) => {
      this.alertaSwal(this.strIconoError, "Error", err);
    });
  }

  confirmarPrematricula(F08COD = "CNT") {
    let parametros = {
      M04IUP: this.M04IUP, M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD,
      M19COD: this.periodoSeleccionado.M19COD, F08COD: F08COD
    };
    this.dataService.ConsultarWS(this.strConfirmarPrematricula, JSON.stringify(parametros)).subscribe((datos: any) => {
      this.confirmacion = datos.DATA[0];
      Swal.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        text: "Prematrícula confirmada",
        showConfirmButton: false,
        timer: 5000
      });
    }, (err: any) => {
      this.alertaSwal(this.strIconoError, "Error", err);
    });
  }

  consultarLobby() {
    if (this.M04IUP != null && this.sedeSeleccionada != null && this.periodoSeleccionado != null) {
      let parametros = {
        M04IUP: this.M04IUP, M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD,
        M19COD: this.periodoSeleccionado.M19COD
      };
      this.dataService.ConsultarWS(this.strLobbyMatricula, JSON.stringify(parametros)).subscribe((datos: any) => {
        this.lobby = datos.DATA[0];
      }, (err: any) => {
        this.alertaSwal(this.strIconoError, "Error", err);
      });
    } else {
      this.lobby = this.resetLobby;
    }
  }

  cambiarFinanciamiento(opcion) {
    this.F08COD = opcion.F08COD;
    this.confirmarPrematricula(this.F08COD);
  }

  autenticarTramite() {
    let parametros = { S00CLA: this.password };
    this.dataService.ConsultarWS(this.strAutenticar, JSON.stringify(parametros)).subscribe((datos: any) => {
      if (datos.OK == "true") {
        this.token = datos.TOKEN;
      }
    }, (err: any) => {
      this.alertaSwal(this.strIconoError, "Error", err);
    });
  }

  formalizarBoleta() {
    let parametros = {
      M04IUP: this.M04IUP, M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD,
      M19COD: this.periodoSeleccionado.M19COD, F08COD: this.F08COD, TOKEN: this.token
    };
    this.dataService.ConsultarWS(this.strGenerarBoleta, JSON.stringify(parametros)).subscribe((datos: any) => {
      this.alertaSwal(this.strIconoSuccess, "Error", datos);
    }, (err: any) => {
      this.alertaSwal(this.strIconoError, "Error", err);
    });
  }

  cambiarImagen(imagen) {
    this.strImg = imagen;
  }

  imagenFalla() {
    this.strImg = "/assets/images/192avatar.png";
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    if (changeEvent.nextId >= 3) {
      if (this.M04IUP == null || this.sedeSeleccionada == null || this.periodoSeleccionado == null) {
        changeEvent.preventDefault();
        this.alertaSwal(this.strIconoWarning, "Formulario incompleto", "Debes seleccionar sede, periodo y carrera");
      } else {
        let mensaje = this.validarLobby();
        if (mensaje.length == 0) {
          this.cerrarBarra.emit(true);
          this.mostrarNoti = false;
          if (changeEvent.nextId == 3) {
            this.actualizarTablas();
          } else {
            if (this.confirmacion.DETALLE.length == 0) {
              changeEvent.preventDefault();
              this.alertaSwal(this.strIconoWarning, "Confirmar Prematrícula", "Debe guardar la selección de materias prematriculadas");
            } else {
              let parametros = {
                M04IUP: this.M04IUP, M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD,
                M19COD: this.periodoSeleccionado.M19COD
              };
              this.dataService.ConsultarWS(this.strFinanciamientos, JSON.stringify(parametros)).subscribe((datos: any) => {
                this.financiamientos = datos.DATA;
              });
            }
          }
        } else {
          changeEvent.preventDefault();
          this.alertaSwal(this.strIconoWarning, "Registra Pendientes", "Debes solucionar lo siguiente para continuar con la matrícula: <br><br>" + mensaje.join(", "));
        }
      }
    } else {
      if (changeEvent.nextId == 2) {
        this.cambioSede();
      }
      this.mostrarNoti = true;
    }
    this.contenedor.scrollIntoView();
  }

  tabAtras() {
    this.activeTab = this.activeTab - 1;
    this.contenedor.scrollIntoView();
  }

  tabAdelante() {
    if (this.activeTab + 1 == 3) {
      if (this.M04IUP != null && this.sedeSeleccionada != null && this.periodoSeleccionado != null) {
        let mensaje = this.validarLobby();
        if (mensaje.length == 0) {
          this.cerrarBarra.emit(true);
          this.mostrarNoti = false;
          this.activeTab = this.activeTab + 1;
          this.actualizarTablas();
        } else {
          this.alertaSwal(this.strIconoWarning, "Registra Pendientes", "Debes solucionar lo siguiente para continuar con la matrícula: <br><br>" + mensaje.join(", "));
        }
      } else {
        this.alertaSwal(this.strIconoWarning, "Formulario incompleto", "Debes seleccionar sede, periodo y carrera");
      }
    } else if (this.activeTab + 1 == 4) {
      if (this.confirmacion.DETALLE.length == 0) {
        this.alertaSwal(this.strIconoWarning, "Confirmar Prematrícula", "Debe guardar la selección de materias prematriculadas");
      } else {
        let parametros = {
          M04IUP: this.M04IUP, M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD,
          M19COD: this.periodoSeleccionado.M19COD
        };
        this.dataService.ConsultarWS(this.strFinanciamientos, JSON.stringify(parametros)).subscribe((datos: any) => {
          this.financiamientos = datos.DATA;
        });
        this.activeTab = this.activeTab + 1;
      }
    }
    else {
      if (this.activeTab + 1 == 2) {
        this.cambioSede();
      }
      this.activeTab = this.activeTab + 1;
    }
    this.contenedor.scrollIntoView();
  }

  autenticar() {
    this.modalService.open(this.contenido, { size: 'xl' });
  }

  confirmarDatos() {
    this.dataService.ConsultarWS(this.strActualizarDatosPersonales, JSON.stringify(this.datosPersonales)).subscribe((datos: any) => {
      Swal.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        text: datos.DATA[0].message,
        showConfirmButton: false,
        timer: 5000
      });
    }, (err: any) => {
      this.alertaSwal(this.strIconoError, "Error", err);
    });
  }

  cambioSede() {
    if (this.sedeSeleccionada != null) {
      let parametros = { M05COD: this.sedeSeleccionada.M05COD };
      this.dataService.ConsultarWS(this.strBuscarPeriodosMatricula, JSON.stringify(parametros)).subscribe((datos: any) => {
        this.periodos = datos.DATA;
        this.periodoSeleccionado = null;
        this.carreras = [];
        this.M04IUP = null;
      });
    } else {
      this.periodos = [];
      this.periodoSeleccionado = null;
      this.carreras = [];
      this.M04IUP = null;
    }
  }

  cambioPeriodo() {
    if (this.periodoSeleccionado != null) {
      let parametros = { M05COD: this.sedeSeleccionada.M05COD, M18COD: this.periodoSeleccionado.M18COD, M19COD: this.periodoSeleccionado.M19COD };
      this.dataService.ConsultarWS(this.strBuscarCarrerasEstudiante, JSON.stringify(parametros)).subscribe((datos: any) => {
        this.carreras = datos.DATA;
        this.M04IUP = null;
      });
    } else {
      this.carreras = [];
      this.M04IUP = null;
    }
  }

  formatoHorario(horario: string, retorna = "string") {
    let filas = horario.match(/.{1,11}/g);

    if (retorna == "string") {
      return filas.join("\n");
    } else if (retorna == "array") {
      return filas;
    }
  }

  obtenerNumeroSemana(letra: string) {
    if (letra == "L") {
      return 1;
    } else if (letra == "M") {
      return 2;
    } else if (letra == "K") {
      return 3;
    } else if (letra == "J") {
      return 4;
    } else if (letra == "V") {
      return 5;
    } else if (letra == "S") {
      return 6;
    }
  }

  renderCalendario() {
    this.calendarOptions = {
      plugins: [timeGridPlugin],
      headerToolbar: {
        left: '',
        center: '',
        right: ''
      },
      initialView: 'timeGridWeek',
      //allDaySlot: false,
      height: 500,
      hiddenDays: [0],
      slotMinTime: '06:00:00',
      slotLabelInterval: '02:00',
      dayHeaderContent: function (arg) {
        let italicEl = document.createElement('i');
        switch (arg.date.getDay()) {
          case 1:
            italicEl.innerHTML = "Lunes";
            break;
          case 2:
            italicEl.innerHTML = "Martes";
            break;
          case 3:
            italicEl.innerHTML = "Miércoles";
            break;
          case 4:
            italicEl.innerHTML = "Jueves";
            break;
          case 5:
            italicEl.innerHTML = "Viernes";
            break;
          case 6:
            italicEl.innerHTML = "Sábado";
            break;
        }

        let arrayOfDomNodes = [italicEl];
        return { domNodes: arrayOfDomNodes }
      },
      events: this.eventos
    }
  }

  validarLobby() {
    let mensaje = [];
    if (this.lobby.TIENE_DEUDAS != "NO") {
      mensaje.push("Pendientes Financieros");
    }
    if (this.lobby.CITA_MATRICULA != "SI") {
      mensaje.push("No es su cita aún");
    }
    if (this.lobby.TERMINOS_AUTORIZADOS != "SI") {
      mensaje.push("No ha aceptado términos");
    }
    if (this.lobby.TIENE_REQUISITOS_PENDIENTES != "NO") {
      mensaje.push("Pendientes con la institución");
    }

    return mensaje;
  }

  alertaSwal(icono, titulo, mensaje) {
    (<HTMLImageElement>(document.getElementById("alerta-imagen"))).src = icono;
    (<HTMLElement>(document.getElementById("alerta-mensaje"))).innerHTML = mensaje;
    (<HTMLElement>(document.getElementById("alerta-titulo"))).textContent = titulo;
    let body = document.getElementById("html-alerta");
    Swal.fire({
      html: body.innerHTML
    });
  }
}
